module.exports = __webpack_public_path__ + "static/media/kiss.80502d0b.png";